export const CircledCheckIcon = ({ className}) => {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x={0.25}
        y={0.25}
        width={47.5}
        height={47.5}
        rx={23.75}
        fill="#D6FFD2"
        fillOpacity={0.3}
      />
      <rect
        x={0.25}
        y={0.25}
        width={47.5}
        height={47.5}
        rx={23.75}
        stroke="#8BFB81"
        strokeWidth={0.5}
      />
      <g clipPath="url(#clip0_2792_53370)">
        <path
          d="M20.25 24.75L22.5 27L27.75 21.75"
          stroke="#13EF00"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24 33C28.9706 33 33 28.9706 33 24C33 19.0294 28.9706 15 24 15C19.0294 15 15 19.0294 15 24C15 28.9706 19.0294 33 24 33Z"
          stroke="#13EF00"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2792_53370">
          <rect
            width={24}
            height={24}
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
